import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import { environment } from '../../environments/environment';
import { Statement } from '../models/statement/statement.model';
import { User } from '../models/user/user.model';
import { ApiHelperService } from './api-helper.service';

@Injectable({
    providedIn: 'root',
})
export class UploadService {

    constructor(
        private api: ApiHelperService
    ) { }

    // TODO (jacob): When is this called?
    addNewLogo(merchantId: string, fileToUpload: File): Promise<{ logoUrl: string }> {
        return fileToUpload.arrayBuffer().then((buffer) =>
            this.api.apiCallSane(
                `/merchants/${merchantId}/logo`,
                'POST',
                new HttpHeaders({ 'Content-Type': fileToUpload.type || 'application/octet-stream' }),
                null,
                buffer,
                { authenticate: true, setRoot: true }
            )
        ) as Promise<{ logoUrl: string }>;
    }

    addNewOrganizationLogo(organizationId: string, fileToUpload: File): Promise<{ logoUrl: string }> {
        return fileToUpload.arrayBuffer().then((buffer) =>
            this.api.apiCallSane(
                `/organizations/${organizationId}/logo`,
                'POST',
                new HttpHeaders({ 'Content-Type': fileToUpload.type || 'application/octet-stream' }),
                null,
                buffer,
                { authenticate: true, setRoot: true }
            )
        ) as Promise<{ logoUrl: string }>;
    }

    getLogoFilePath(fileToUploadName) {
        return `logo-uploads/${fileToUploadName}`;
    }

    imageToPdf(img: File): Promise<File> {
        return img.arrayBuffer().then(data => {

            const oldFileType = img.type.split('/')[1];
            const oldFileName = img.name;
            const dataArray = new Uint8Array(data);

            const doc = new jsPDF('p', 'pt', 'a4', false);
            doc.addImage(dataArray, oldFileType, 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight(), 'img');

            //replaces extension with .pdf
            const newFileName = oldFileName.lastIndexOf('.') === -1 ? oldFileName + '.pdf' : oldFileName.substr(0, oldFileName.lastIndexOf('.')) + '.pdf';
            return new File([doc.output('arraybuffer')], newFileName, { type: 'application/pdf' });
        });
    }

    async uploadStatement(
        pdf: File,
        organizationName: string,
        merchantId: string,
        statementId: string,
        user: User
    ): Promise<Statement> {

        const params = {
            userName: user.fullName,
            ssmr: user.hasReviewerAccess,
            organizationName: organizationName,
            merchantId: merchantId,
            statementId: statementId,
            env: environment.rootDomain
        };

        let query = '';
        for (const key in params)
            query += `${key}=${encodeURI(params[key])}&`;

        query = query.slice(0, -1);


        return pdf.arrayBuffer()
            .then(blob =>
                this.api.apiCallSane(
                    `/process-statement?${query}`,
                    'POST',
                    new HttpHeaders({ 'Content-Type': 'application/pdf' }),
                    null,
                    blob,
                    { authenticate: true, setRoot: true, isPdf: true }))
            .then((data: unknown) => (data as Statement))
            .catch(async e => {
                e.message += '\nin auth.login: Could not getUserByCompatId';
                await this.api.reportAndRethrow(e);
                // This will never happen, but is required to appease
                // typescript
                return {} as Statement
            });
    }
}
